module.exports = __webpack_public_path__ + "static/media/MH.ff916506.svg";